exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1, h2, h3,\nh4, h5, h6 {\n  color: #212121;\n  line-height: 1.2;\n  margin: 30px 0 20px 0;\n  font-weight: 500;\n  font-family: \"futura-pt\", sans-serif; }\n\nh1 {\n  font-size: 40px; }\n\nh2 {\n  font-size: 32px; }\n\nh3 {\n  font-size: 24px; }\n\nh4 {\n  font-size: 18px; }\n\nh5 {\n  font-size: 16px; }\n\nh6 {\n  font-size: 12px; }\n\nstrong {\n  font-weight: 700;\n  color: #212121; }\n\n.InputError {\n  margin-top: 4px;\n  color: #de4a4a;\n  font-size: 12px; }\n  .InputError > div {\n    line-height: 1.2;\n    margin: 4px 0; }\n  .InputError:first-letter {\n    text-transform: capitalize; }\n", ""]);

// exports
